export const ptbr = {
  translation: {
    "Belimo Energy Valve": "Energy Valve da Belimo",
    Yes: "Sim",
    No: "Não",
    "You cannot go back from this position":
      "Você não pode voltar desta posição",
    Chapters: "Capítulos",
    Start: "Início",
    "Connecting to the Energy Valve":
      "Conexão com a Energy Valve",
    "Control Source": "Fonte de controle",
    "Do you know the design flow rate?":
      "Você conhece a taxa de vazão do projeto?",
    "Flow Control": "Controle de fluxo",
    "Is the building running off fixed or varying flow temperatures?":
      "O edifício está funcionando em temperaturas fixas ou de fluxo variável?",

    "Varying flow temperatures (Delta T Manager Scaling)":
      "Variação de temperaturas de fluxo (Delta T Manager Scaling)",

    "Fixed flow temperatures (Delta T Manager)":
      "Temperaturas fixas de fluxo (Delta T Manager)",
    "I am not sure": "Não tenho certeza",
    "Delta T Manager": "Gerenciador do Delta T",
    Scaling: "Escala",
    "Do you know the power output?":
      "Você conhece a potência de saída?",
    "Yes (Power Control)": "Sim (Controle de potência)",
    "No (Position Control)": "Não (Controle de posição)",
    "Power Control": "Controle de potência",
    "Position Control": "Controle de posição",
    "Onboard Data Analysis": "Análise de dados a bordo",
    "Did you get a clear result from the Energy Valve?":
      "Você obteve um resultado claro com a Energy Valve?",
    "How do you want to setup your Energy Valve?":
      "Como você quer configurar sua Energy Valve?",
    "Would you like to connect to the cloud?":
      "Você gostaria de se conectar com a nuvem?",
    "Cloud Connectivity": "Conectividade da nuvem",
    "Onboard Diagnostics / Download Data":
      "Diagnóstico a bordo / Download de dados",
    "Download Data": "Baixar dados",
    "Send optimization request":
      "Enviar pedido de otimização",
    End: "Fim",

    Subtitles: "Subtítulos",
    Repeat: "Repita",
    Continue: "Continuar",
  },
};
